/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A cabin category group describes cabin with the same main category code
 * @export
 * @interface CabinCategoryGroup
 */
export interface CabinCategoryGroup {
    /**
     * The main category code
     * @type {string}
     * @memberof CabinCategoryGroup
     */
    mainCode: string;
    /**
     * The name of the catgery group
     * @type {string}
     * @memberof CabinCategoryGroup
     */
    name: string;
}

/**
 * Check if a given object implements the CabinCategoryGroup interface.
 */
export function instanceOfCabinCategoryGroup(value: object): value is CabinCategoryGroup {
    if (!('mainCode' in value) || value['mainCode'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CabinCategoryGroupFromJSON(json: any): CabinCategoryGroup {
    return CabinCategoryGroupFromJSONTyped(json, false);
}

export function CabinCategoryGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinCategoryGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'mainCode': json['mainCode'],
        'name': json['name'],
    };
}

export function CabinCategoryGroupToJSON(json: any): CabinCategoryGroup {
    return CabinCategoryGroupToJSONTyped(json, false);
}

export function CabinCategoryGroupToJSONTyped(value?: CabinCategoryGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mainCode': value['mainCode'],
        'name': value['name'],
    };
}

